import { isKnownIsoCountryCodeSegment } from './locale-segment-catalog';
import {
  isLocaleShapedSegment,
  isSlugShapedSegment,
  segmentValueClass,
} from './segment-value-class';

export type RouteSegmentRole =
  | 'identifier'
  | 'content_slug'
  | 'operation_name'
  | 'other';

const CAMEL_OR_PASCAL_OPERATION_PATTERN = /[A-Z]/;
const LOWERCASE_LETTER_PATTERN = /[a-z]/;
const DELIMITED_OPERATION_PATTERN = /[-_]/;

export function classifyRouteSegmentRole(segment: string): RouteSegmentRole {
  if (!segment) {
    return 'other';
  }

  const valueClass = segmentValueClass(segment);

  if (valueClass === 'identifier' || valueClass === 'colon_delimited') {
    return 'identifier';
  }

  if (isSlugShapedSegment(segment)) {
    return 'content_slug';
  }

  if (valueClass !== 'route_word') {
    return 'other';
  }

  if (isLocaleShapedSegment(segment) || isKnownIsoCountryCodeSegment(segment)) {
    return 'other';
  }

  if (
    isCamelOrPascalCaseOperation(segment) ||
    isDelimitedOperationSlug(segment)
  ) {
    return 'operation_name';
  }

  return 'other';
}

export function isClosedOperationNameFamily(
  values: readonly string[],
): boolean {
  if (values.length === 0) {
    return false;
  }

  return values.every(
    (value) => classifyRouteSegmentRole(value) === 'operation_name',
  );
}

function isCamelOrPascalCaseOperation(segment: string): boolean {
  return (
    CAMEL_OR_PASCAL_OPERATION_PATTERN.test(segment) &&
    LOWERCASE_LETTER_PATTERN.test(segment)
  );
}

function isDelimitedOperationSlug(segment: string): boolean {
  return (
    DELIMITED_OPERATION_PATTERN.test(segment) &&
    LOWERCASE_LETTER_PATTERN.test(segment)
  );
}
